import React, { useEffect, useState } from 'react';

function ViewLead({ LeadData }) {
  const [leadData, setLeadData] = useState({});
  const [investmentTypesText, setInvestmentTypesText] = useState('');

  useEffect(() => {
    if (LeadData) {
      setLeadData(LeadData);

      // ✅ Extract product investment type names and display as comma-separated text
      let typeNames = '';
      if (LeadData.ClientCompanyTypeNames) {
        typeNames = LeadData.ClientCompanyTypeNames;
      }
      setInvestmentTypesText(typeNames);
    }
  }, [LeadData]);

  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Client Name</label>
            <input
              type="text"
              className="form-control"
              name="ClientName"
              value={leadData.ClientName ?? ''}
              disabled
            />
          </div>
        </div>

        <div className="col-lg-6 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Mobile No</label>
            <input
              type="text"
              className="form-control"
              name="MobileNumber"
              value={leadData.MobileNumber ?? ''}
              disabled
            />
          </div>
        </div>

        <div className="col-lg-6 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Email ID</label>
            <input
              type="text"
              className="form-control"
              name="EmailId"
              value={leadData.EmailId ?? ''}
              disabled
            />
          </div>
        </div>

        {/* ✅ Product Investment Text (View Only) */}
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="mb-3">
            <label className="form-label">Product Investment</label>
            <input
              type="text"
              className="form-control"
              name="ProductInvestment"
              value={investmentTypesText}
              disabled
            />
          </div>
        </div>

        {/* Description */}
        <div className="col-lg-12">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control h-100"
              rows="3"
              name="Description"
              value={leadData.Description ?? ''}
              disabled
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewLead;
